import { Provider } from '@angular/core';
import { provideTranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { translation } from '../i18n/translation.constant';
import { provideRegistrationStore } from './registration-store.provider';

export function provideRegistration(): Provider {
  return [
    provideRegistrationStore(),
    provideTranslationDictionaryMapping(translation),
  ];
}
